var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTooltipDisk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5487_732)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.453 8.50039H15.476C15.3514 6.42585 14.471 4.46885 13.0013 2.99937C11.5317 1.52989 9.57456 0.64977 7.5 0.525391V4.55139C8.50864 4.66491 9.44891 5.11735 10.167 5.8347C10.8851 6.55206 11.3385 7.49187 11.453 8.50039Z",
    stroke: "#ADB5BD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.99983 2.81439C3.94131 3.15728 2.98853 3.76616 2.23272 4.58273C1.4769 5.39929 0.943353 6.39621 0.683156 7.47803C0.422959 8.55985 0.444824 9.69035 0.746659 10.7613C1.04849 11.8323 1.62019 12.8078 2.40702 13.5945C3.19384 14.3813 4.16945 14.9528 5.24044 15.2545C6.31143 15.5562 7.44193 15.578 8.52372 15.3176C9.60551 15.0573 10.6024 14.5236 11.4188 13.7677C12.2353 13.0118 12.8441 12.059 13.1868 11.0004",
    stroke: "#ADB5BD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 10.5C7.82843 10.5 8.5 9.82843 8.5 9C8.5 8.17157 7.82843 7.5 7 7.5C6.17157 7.5 5.5 8.17157 5.5 9C5.5 9.82843 6.17157 10.5 7 10.5Z",
    stroke: "#ADB5BD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5487_732"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltipDisk);
export default __webpack_public_path__ + "static/media/tooltipDisk.d88d3a08b5dafcca2c4b1b38471522a3.svg";
export { ForwardRef as ReactComponent };